import {defineType} from 'sanity'
import {ComponentPreview} from './ComponentPreview'
import {TfiLayoutMediaLeft} from 'react-icons/tfi'

export default defineType({
  type: 'object',
  name: 'media-text',
  title: 'Media + Text',
  icon: TfiLayoutMediaLeft,
  components: {
    preview: (props) => <ComponentPreview {...props} />,
  },
  preview: {
    select: {
      title: 'text',
      media: 'image',
    },
  },
  fields: [
    {
      name: 'position',
      type: 'string',
      title: 'Image Position',
      options: {
        list: [
          {title: 'Left', value: 'left'},
          {title: 'Right', value: 'right'},
        ],
      },
    },
    {
      name: 'image',
      type: 'image',
      title: 'Image',
    },
    {
      name: 'text',
      type: 'portableText',
      title: 'Content',
    },
  ],
})
